import { render } from "./SidebarBox.vue?vue&type=template&id=40085fe7"
import script from "./SidebarBox.vue?vue&type=script&lang=ts"
export * from "./SidebarBox.vue?vue&type=script&lang=ts"

import "./SidebarBox.vue?vue&type=style&index=0&id=40085fe7&lang=scss"
script.render = render

export default script